import { render, staticRenderFns } from "./worksList.vue?vue&type=template&id=73eba601&scoped=true"
import script from "./worksList.vue?vue&type=script&lang=js"
export * from "./worksList.vue?vue&type=script&lang=js"
import style0 from "./worksList.vue?vue&type=style&index=0&id=73eba601&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73eba601",
  null
  
)

export default component.exports